// Settings used by the mocks to obtain different scenarios by Storybook and tests
const mockSettingsDefaults = {
	checkDOB: true,
	checkZipCode: true,
	codeSendError: false,
	disableMFAFeatures: false,
	emailNotVerified: false,
	errorFetchingSecurityQuestion: false,
	expiredToken: false,
	incorrectPassword: false,
	invalidPassword: false,
	invalidUserFields: false,
	isASHLinkFitnessUserType: false,
	isASHLinkPrimaryUser: false,
	isASHLinkRegistration: false,
	isMFAFinalAttempt: false,
	isMFALockoutUser: false,
	showMfaOnboarding: false,
	maximumAttemptReached: false,
	memberNotFound: false,
	mfaEnabled: false, // Multi-factor authentication enabled
	mfaOptionsCount: 0,
	mfaEmailVerification: 'NotVerified',
	mfaPhoneNumberVerification: 'NotVerified',
	networkDelay: 1000,
	noImages: false,
	otpValidationError: false,
	passwordRulesServerError: false,
	registrationEmailInvalid: false,
	registrationLegacyUser: false,
	registrationRequireNpi: false,
	registrationTaxIdInvalid: false,
	registrationTokenIsExpired: false,
	resendEmailError: false,
	returnError: false,
	returnErrorCode: 500,
	returnMessage: '',
	returnMFAStatusToggleError: false,
	returnMfaTooManyCodes: false,
	returnNullValue: false,
	returnPrimaryAccountError: false,
	securityQuestionServerError: false,
	showAccountExistsGenericErrorOnRoleSubmit: false,
	showAPIGenericErrorOnRoleSubmitWithLogin: false,
	totalCount: 100,
	useLegacyUserVerificationHandler: false,
	wrongSecurityAnswer: false,
};
const mockSettings = { ...mockSettingsDefaults };

export { mockSettings, mockSettingsDefaults };
